import { de_CreateSimulationCommand, se_CreateSimulationCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class CreateSimulationCommand extends $Command.classBuilder()
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
    ];
})
    .s("SimulationService", "CreateSimulation", {})
    .n("SimulationServiceClient", "CreateSimulationCommand")
    .f(void 0, void 0)
    .ser(se_CreateSimulationCommand)
    .de(de_CreateSimulationCommand)
    .build() {
}
